export default __webpack_public_path__ + "images/c7c7ef390ee2e881dd9ef49a76365c1e-icon-extra-bid-avatar.svg";